/**
 * Groups raw ticket reason data by category.
 * @param {Array} data - Raw API response array [{ category, reason, order }, ...]
 * @returns {{ hasCategories: boolean, reasons: string[], grouped: Record<string, string[]> }}
 */
const groupTicketReasonsByCategory = (data) => {
  const hasCategories = data.some((item) => item.category?.trim());
  if (hasCategories) {
    const grouped = {};
    data.forEach((item) => {
      const cat = item.category || "General";
      (grouped[cat] ??= []).push({ reason: item.reason, order: item.order });
    });
    const result = {};
    Object.entries(grouped).forEach(([cat, reasons]) => {
      result[cat] = reasons.sort((a, b) => a.order - b.order).map((r) => r.reason);
    });
    return { hasCategories: true, reasons: [], grouped: result };
  }
  const sorted = [...data].sort((a, b) => a.order - b.order);
  return { hasCategories: false, reasons: sorted.map((r) => r.reason), grouped: {} };
};

export default groupTicketReasonsByCategory;
